import { set } from 'lodash';
import { NewClassRequest } from '../classes/NewClassRequest';
import { NotificationManager } from 'react-notifications';

export const initForm = {
  email: '',
};

export const resendConfirmationEmail = async (
  form,
  props,
  timerActive,
  setTimerActive,
  setTimeLeft,
  setButtonDisabled
) => {
  const request = new NewClassRequest(
    `${process.env.REACT_APP_URL_API_LARAVEL}/auth/confirmation`,
    'post',
    null,
    {
      email: form.email,
      app_id: 2,
    }
  );

  const validateEmail = await request.executeRequest();

  if (validateEmail.response && validateEmail.response.code === 429) {
    setButtonDisabled(true);
    setTimerActive(true);
    setTimeLeft(validateEmail.response.remaining_time);
    NotificationManager.warning(
      validateEmail.response.message ||
        'Has alcanzado el límite de reenvíos. Por favor, espera un momento antes de intentarlo de nuevo.'
    );
    return;
  }

  if (validateEmail.code !== 200) {
    NotificationManager.error(validateEmail.response.message);
    return;
  }

  if (validateEmail.response && validateEmail.response.error) {
    NotificationManager.error(validateEmail.response.message);
    return;
  }

  if (
    validateEmail.response &&
    typeof validateEmail.response.message === 'string' &&
    validateEmail.response.message !== ''
  ) {
    setTimeout(() => {
      NotificationManager.success(validateEmail.response.message);
    }, 500);

    props.history.push('/home');
  }
};
